export default __webpack_public_path__ + "static/media/300.9d1fdf9f.jpg";